// extracted by mini-css-extract-plugin
export default {"btn":"index_btn__0d98w","text":"index_text__x2E7i","error":"index_error__4HkMn"};